module.exports = __webpack_public_path__ + "img/news-5.e5d666e5.jpeg";